import { AutoCompleteInput, Option } from '../autocomplete/auto-complete-input';

type AutoCompleteFilterProps = {
    options?: Array<{ label: string; value: string }>;
    value?: Option;
    onValueChange?: (value: Option) => void;
    placeholder?: string;
    onInputChange?: (value: string) => void;
    isLoading?: boolean;
};

export const AutoCompleteFilter = ({
    options = [],
    value = { label: '', value: '' },
    onValueChange,
    placeholder = 'Select option',
    onInputChange,
    isLoading = false,
}: AutoCompleteFilterProps) => {
    return (
        <div>
            <AutoCompleteInput
                options={options || []}
                emptyMessage="No match found!"
                onValueChange={onValueChange}
                placeholder={placeholder}
                value={value}
                onInputChange={onInputChange}
                isLoading={isLoading}
            />
        </div>
    );
};

AutoCompleteFilter.displayName = 'AutoCompleteFilter';
